// Angular
import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
// Object-Path
import * as objectPath from 'object-path';
// Layout
import { LayoutConfigService, LoaderService } from '../../../../core/_base/layout';

@Component({
  selector: 'kt-loading-screen',
  templateUrl: './loading-service.component.html',
  styleUrls: ['./loading-service.component.scss']
})
export class LoadingService implements OnInit {

	loaderLogo: string;
	loaderType: string;
	loaderMessage: string;

	@ViewChild('loaderScreen', {static: true}) loaderScreen: ElementRef;
	@Input() loaderScreenData:any;
	/**
	 * Component constructor
	 *
	 * @param el: ElementRef
	 * @param layoutConfigService: LayoutConfigService
	 * @param loaderScreenService: SplachScreenService
	 */
	constructor(
		private el: ElementRef,
		private layoutConfigService: LayoutConfigService,
		private loaderScreenService: LoaderService) {
	}

	/**
	 * @ Lifecycle sequences => https://angular.io/guide/lifecycle-hooks
	 */

	/**
	 * On init
	 */
	ngOnInit() {
		
		// init splash screen, see loader option in layout.config.ts
		const loaderConfig = this.layoutConfigService.getConfig('loader');
		this.loaderType = objectPath.get(loaderConfig, 'type');
		this.loaderLogo = objectPath.get(loaderConfig, 'logo');

		 if(localStorage.getItem('loadingLogo')){
			this.loaderLogo = localStorage.getItem('loadingLogo')
     	}
		this.loaderMessage = objectPath.get(loaderConfig, 'message');
		// this.loaderMessage = "testingg message";

		this.loaderScreenService.init(this.loaderScreen);
	}

}
